module.exports = __webpack_public_path__ + "static/img/slaflow3.98ae060.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaflow3.png
// module id = dJPY
// module chunks = 2